import {Utils} from "../Modules/Utils";

Utils.executeWhenDocumentIsReady( () => {
    const urlHash = window.location.href.split("#")[1]
    const target = document.getElementById(urlHash)

    if (urlHash && target) {
        const targetOffsetTop =
            target.getBoundingClientRect().top + window.pageYOffset
        const scrollToPosition = targetOffsetTop - 100

        window.scrollTo({
            top: scrollToPosition,
            behavior: "smooth",
        })
    }
})
